import { FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { UseFormReturn } from "react-hook-form"
import { CatalogFormData } from "../catalog-form-schema"

interface LogisticsProps {
  form: UseFormReturn<CatalogFormData>
}

export function Logistics({ form }: LogisticsProps) {
  return (
    <div className="grid grid-cols-3 gap-4">
      <FormField
        control={form.control}
        name="eventCost"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Event Cost (USD)</FormLabel>
            <FormControl>
              <Input
                type="number"
                placeholder="0"
                className="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                onWheel={(e) => e.currentTarget.blur()}
                {...field}
                onChange={(e) => field.onChange(parseInt(e.target.value))}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="minVolunteers"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Minimum Volunteers</FormLabel>
            <FormControl>
              <Input
                type="number"
                placeholder="Enter minimum number of volunteers"
                className="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                onWheel={(e) => e.currentTarget.blur()}
                {...field}
                onChange={(e) => field.onChange(parseInt(e.target.value))}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="maxVolunteers"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Maximum Volunteers <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Input
                type="number"
                placeholder="Enter maximum number of volunteers"
                className="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                onWheel={(e) => e.currentTarget.blur()}
                {...field}
                onChange={(e) => field.onChange(parseInt(e.target.value))}
              />
            </FormControl>
            <FormDescription>
              The maximum number of volunteers that can participate in this opportunity
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  )
}